import {
    DataTable as SharedDataTable,
    type DataTableProps as SharedDataTableProps,
} from "@/components/shared/DataTable";
import { AlertCircle, SearchX, Sparkles } from "lucide-react";

type SkillsDataTableProps<TData, TValue> = Omit<
    SharedDataTableProps<TData, TValue>,
    "entityLabel" | "emptyState" | "errorState" | "filteredState"
>;

export function DataTable<TData, TValue>(
    props: SkillsDataTableProps<TData, TValue>
) {
    return (
        <SharedDataTable
            {...props}
            entityLabel="skills"
            errorState={{
                icon: (
                    <AlertCircle className="text-muted-foreground/50 size-10" />
                ),
                title: "Failed to load skills",
                body: "Something went wrong. Please try again.",
            }}
            filteredState={{
                icon: <SearchX className="text-muted-foreground/50 size-10" />,
                title: "No skills match your filters",
                body: "Try adjusting your search or filters.",
            }}
            emptyState={{
                icon: <Sparkles className="text-muted-foreground/50 size-10" />,
                title: "No skills yet",
                body: "Create your first skill to get started.",
            }}
        />
    );
}
